import React, { useState, useEffect, useRef } from "react";

import { buttonStyles } from "../../stylesGenerales/buttons";
import { comboBoxStyles } from "../../stylesGenerales/combobox";

const TemasCapacitacionTable = ({

    temas,

    handleEdit,

    handleDelete,

    handlePrepareActivate,

    paginaActual,

    totalPaginas,

    setPaginaActual

}) => {

    const [menuAbierto, setMenuAbierto] = useState(null);

    const containerRef = useRef(null);

    // Cerrar menú al hacer clic fuera
    useEffect(() => {

        const handleClickOutside = event => {

            if (
                containerRef.current &&
                !containerRef.current.contains(event.target)
            ) {
                setMenuAbierto(null);
            }
        };

        document.addEventListener(
            "mousedown",
            handleClickOutside
        );

        return () =>
            document.removeEventListener(
                "mousedown",
                handleClickOutside
            );

    }, []);

    const toggleMenu = id => {

        setMenuAbierto(
            menuAbierto === id
                ? null
                : id
        );
    };

    return (

        <div
            style={{
                background: "#fff",
                borderRadius: "12px",
                padding: "20px 30px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
            }}
            ref={containerRef}
        >

            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse"
                }}
            >

                <thead>

                    <tr>

                        <th
                            style={{
                                borderBottom: "2px solid #eee",
                                padding: "10px",
                                textAlign: "left"
                            }}
                        >
                            Nombre
                        </th>

                        <th
                            style={{
                                borderBottom: "2px solid #eee",
                                padding: "10px",
                                textAlign: "center"
                            }}
                        >
                            Estado
                        </th>

                        <th
                            style={{
                                borderBottom: "2px solid #eee",
                                padding: "10px",
                                textAlign: "center"
                            }}
                        >
                            Acciones
                        </th>

                    </tr>

                </thead>

                <tbody>

                    {temas.length > 0 ? (

                        temas.map(tema => (

                            <tr key={tema.idtemacapacitacion}>

                                <td
                                    style={{
                                        padding: "10px",
                                        borderBottom: "1px solid #f0f0f0"
                                    }}
                                >
                                    {tema.nombretema}
                                </td>

                                <td
                                    style={{
                                        padding: "10px",
                                        textAlign: "center",
                                        color: tema.estado
                                            ? "green"
                                            : "red",
                                        fontWeight: "600",
                                        borderBottom: "1px solid #f0f0f0"
                                    }}
                                >
                                    {tema.estado
                                        ? "Activo"
                                        : "Inactivo"}
                                </td>

                                <td
                                    style={{
                                        padding: "10px",
                                        textAlign: "center",
                                        borderBottom: "1px solid #f0f0f0",
                                        position: "relative"
                                    }}
                                >

                                    {/* COMBOBOX */}
                                    <div style={comboBoxStyles.container}>

                                        <button
                                            onClick={() =>
                                                toggleMenu(
                                                    tema.idtemacapacitacion
                                                )
                                            }
                                            style={
                                                comboBoxStyles.button.base
                                            }
                                            onMouseEnter={e =>
                                            (
                                                e.currentTarget.style.background =
                                                comboBoxStyles.button.hover.background
                                            )
                                            }
                                            onMouseLeave={e =>
                                            (
                                                e.currentTarget.style.background =
                                                comboBoxStyles.button.base.background
                                            )
                                            }
                                        >
                                            Opciones ▾
                                        </button>

                                        {menuAbierto === tema.idtemacapacitacion && (

                                            <div
                                                style={
                                                    comboBoxStyles.menu.container
                                                }
                                            >

                                                {/* EDITAR */}
                                                <button
                                                    onClick={() =>
                                                        handleEdit(tema)
                                                    }
                                                    disabled={!tema.estado}
                                                    style={{
                                                        ...comboBoxStyles.menu.item.editar.base,

                                                        ...(
                                                            tema.estado
                                                                ? {}
                                                                : comboBoxStyles.menu.item.editar.disabled
                                                        )
                                                    }}
                                                    onMouseEnter={e => {

                                                        if (tema.estado)

                                                            e.currentTarget.style.background =
                                                                comboBoxStyles.menu.item.editar.hover.background;
                                                    }}
                                                    onMouseLeave={e => {

                                                        if (tema.estado)

                                                            e.currentTarget.style.background =
                                                                comboBoxStyles.menu.item.editar.base.background;
                                                    }}
                                                >
                                                    Editar
                                                </button>

                                                {/* ACTIVAR / DESACTIVAR */}
                                                {tema.estado ? (

                                                    <button
                                                        onClick={() =>
                                                            handleDelete(tema)
                                                        }
                                                        style={
                                                            comboBoxStyles.menu.item.desactivar.base
                                                        }
                                                        onMouseEnter={e =>
                                                        (
                                                            e.currentTarget.style.background =
                                                            comboBoxStyles.menu.item.desactivar.hover.background
                                                        )
                                                        }
                                                        onMouseLeave={e =>
                                                        (
                                                            e.currentTarget.style.background =
                                                            comboBoxStyles.menu.item.desactivar.base.background
                                                        )
                                                        }
                                                    >
                                                        Desactivar
                                                    </button>

                                                ) : (

                                                    <button
                                                        onClick={() =>
                                                            handlePrepareActivate(tema)
                                                        }
                                                        style={
                                                            comboBoxStyles.menu.item.activar.base
                                                        }
                                                        onMouseEnter={e =>
                                                        (
                                                            e.currentTarget.style.background =
                                                            comboBoxStyles.menu.item.activar.hover.background
                                                        )
                                                        }
                                                        onMouseLeave={e =>
                                                        (
                                                            e.currentTarget.style.background =
                                                            comboBoxStyles.menu.item.activar.base.background
                                                        )
                                                        }
                                                    >
                                                        Activar
                                                    </button>

                                                )}

                                            </div>

                                        )}

                                    </div>

                                </td>

                            </tr>

                        ))

                    ) : (

                        <tr>

                            <td
                                colSpan="3"
                                style={{
                                    textAlign: "center",
                                    padding: "20px"
                                }}
                            >
                                No hay temas registrados
                            </td>

                        </tr>

                    )}

                </tbody>

            </table>

            {/* PAGINACIÓN */}
            {totalPaginas > 1 && (

                <div
                    style={{
                        marginTop: "20px",
                        textAlign: "center"
                    }}
                >

                    {Array.from(
                        { length: totalPaginas },
                        (_, i) => (

                            <button
                                key={i + 1}
                                onClick={() =>
                                    setPaginaActual(i + 1)
                                }
                                style={{
                                    ...buttonStyles.paginacion.base,

                                    ...(
                                        paginaActual === i + 1
                                            ? buttonStyles.paginacion.activo
                                            : buttonStyles.paginacion.inactivo
                                    )
                                }}
                            >
                                {i + 1}
                            </button>

                        )
                    )}

                </div>

            )}

        </div>
    );
};

export default TemasCapacitacionTable;